import { MenuItem } from './_models/menu.item';

export const navigation: MenuItem[] = [
  {
    title: true,
    name: 'Funcionalidades',
    wrapper: {
      element: 'span'
    },
    class: 'text-center'
  },
  {
    name: 'Home',
    url: '/home',
    icon: 'fas fa-home'
  },
  {
    name: 'Etiquetas Marcopolo',
    url: '/etiquetas-marcopolo',
    claim: { nome: 'EtiquetasMarcopolo', valor: 'Full' },
    icon: 'fas fa-ticket-alt'
  },
  {
    name: 'Etiquetas Mascarello',
    url: '/etiquetas-mascarello',
    claim: { nome: 'EtiquetasMarcopolo', valor: 'Full' },
    icon: 'fas fa-ticket-alt'
  },
  {
    name: 'Log',
    url: '/log',
    claim: { nome: 'Log', valor: 'Full' },
    icon: 'far fa-eye'
  },
  {
    name: 'Ger. Usuários',
    url: '/gerusuarios',
    claim: { nome: 'Usuarios', valor: 'Full' },
    icon: 'fas fa-users'
  },
  {
    title: true,
    name: 'Usuários',
    wrapper: {
      element: 'span'
    },
    class: 'text-center'
  },
  {
    name: 'Sair',
    url: '/usuarios/sair',
    icon: 'fas fa-sign-out-alt'
  }
];
